import { Box, Typography, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { getStyle } from './constants';

const StyleChip = ({ style, size = 'sm' }) => {
  const { t } = useTranslation();
  const meta = getStyle(style);
  if (!style || style === 'NONE') return null;
  const px = size === 'sm' ? 0.6 : 0.85;
  const fontSize = size === 'sm' ? '0.6rem' : '0.68rem';
  const iconSize = size === 'sm' ? 11 : 13;
  const Icon = meta.Icon;
  return (
    <Tooltip arrow placement="top" title={
      <Box sx={{ p: 0.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.4 }}>
          {Icon && <Icon sx={{ fontSize: 14 }} />}
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 800 }}>{meta.label}</Typography>
        </Box>
        <Typography sx={{ fontSize: '0.7rem', lineHeight: 1.4 }}>
          {t('stockStrength.tradeStyle.' + style + '.tip', meta.tip)}
        </Typography>
      </Box>
    }>
      <Box sx={{
        display: 'inline-flex', alignItems: 'center', gap: 0.35,
        px, py: 0.15, borderRadius: 0.8,
        bgcolor: alpha(meta.color, 0.12),
        border: `1px solid ${alpha(meta.color, 0.35)}`,
        cursor: 'help',
      }}>
        {Icon && <Icon sx={{ fontSize: iconSize, color: meta.color }} />}
        <Typography sx={{
          fontSize, fontWeight: 800, color: meta.color,
          textTransform: 'uppercase', letterSpacing: 0.3, lineHeight: 1,
        }}>
          {meta.label}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default StyleChip;
